import {
    Circle as CircleStyle,
    Fill,
    RegularShape,
    Stroke,
    Style,
    Text
} from 'ol/style'
import { Modify } from 'ol/interaction'
import { LineString, Point } from 'ol/geom'
import { Vector as VectorSource } from 'ol/source'
import { Vector as VectorLayer } from 'ol/layer'
import { getArea, getLength } from 'ol/sphere'

import i18n from '../../../i18n';

export const modifyStyle = new Style({
    image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
            color: 'rgba(0, 0, 0, 1)'
            // color: 'rgba(0, 0, 0, 0.7)',
        }),
        fill: new Fill({
            color: 'rgba(0, 0, 0, 1)'
            // color: 'rgba(0, 0, 0, 0.4)',
        })
    }),
    text: new Text({
        text: i18n.t('Drag to modify') || 'Arrastrar para modificar', // Drag to modify
        font: '14px Calibri,sans-serif',
        fill: new Fill({
            color: 'rgba(255, 255, 255, 1)'
        }),
        backgroundFill: new Fill({
            color: 'rgba(0, 0, 0, 0.7)'
        }),
        padding: [2, 2, 2, 2],
        textAlign: 'left',
        offsetX: 15
    })
})

export const sourceMeasurePolygon = new VectorSource()

export const style = new Style({
    fill: new Fill({
        color: 'rgba(0, 81, 162, 0.2)'
        // color: 'rgba(255, 255, 255, 0.2)',
    }),
    stroke: new Stroke({
        color: '#456805',
        lineDash: [0.3, 5], // lineDash: [10, 10],
        width: 3
    }),
    image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0.7)'
        }),
        fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)'
        })
    })
})

export const vectorMeasurePolygon = new VectorLayer({
    source: sourceMeasurePolygon,
    style: function (feature) {
        return styleFunction(feature, true)
    }
})

export const modify = new Modify({ source: sourceMeasurePolygon, style: modifyStyle })

export let tipPoint

export function styleFunction(feature, segments, drawType, tip) {
    const styles = [style]
    const geometry = feature.getGeometry()
    const type = geometry.getType()
    let point, label, line
    if (!drawType || drawType === type) {
        if (type === 'Polygon') {
            point = geometry.getInteriorPoint()
            label = formatArea(geometry)
            line = new LineString(geometry.getCoordinates()[0])
        } else if (type === 'LineString') {
            point = new Point(geometry.getLastCoordinate())
            label = formatLength(geometry)
            line = geometry
        }
    }
    if (segments && line) {
        let count = 0
        line.forEachSegment(function (a, b) {
            const segment = new LineString([a, b])
            const label = formatLength(segment)
            if (segmentStyles.length - 1 < count) {
                segmentStyles.push(segmentStyle.clone())
            }
            const segmentPoint = new Point(segment.getCoordinateAt(0.5))
            segmentStyles[count].setGeometry(segmentPoint)
            segmentStyles[count].getText().setText(label)
            styles.push(segmentStyles[count])
            count++
        })
    }
    if (label) {
        labelStyle.setGeometry(point)
        labelStyle.getText().setText(label)
        styles.push(labelStyle)
    }
    if (tip && type === 'Point' && !modify.getOverlay().getSource().getFeatures().length) {
        tipPoint = geometry
        tipStyle.getText().setText(tip)
        styles.push(tipStyle)
    }
    return styles
}

const labelStyle = new Style({
    text: new Text({
        font: '14px Calibri,sans-serif',
        fill: new Fill({
            // color: 'rgba(255, 255, 255, 1)',
            color: 'rgba(0, 0, 0, 1)' // color texto tip actual

        }),
        backgroundFill: new Fill({
            // color: 'rgba(0, 0, 0, 0.7)',
            color: 'rgba(245, 215, 0, 1)' // color tip actual

        }),
        padding: [3, 3, 3, 3],
        textBaseline: 'bottom',
        offsetY: -15
    }),
    image: new RegularShape({
        radius: 8,
        points: 3,
        angle: Math.PI,
        displacement: [0, 10],
        fill: new Fill({
            // color: 'rgba(0, 0, 0, 0.7)',
            color: 'rgba(245, 215, 0, 1)' // color triangulo tip actual
        })
    })
})

const tipStyle = new Style({
    text: new Text({
        font: '14px Calibri,sans-serif',
        fill: new Fill({
            color: 'rgba(255, 255, 255, 1)' // color texto click para ...
            // color: 'rgba(255, 255, 255, 1)',
        }),
        backgroundFill: new Fill({
            color: 'rgba(0, 0, 0, 0.7)' // color relleno texto click para
            // color: 'rgba(0, 0, 0, 0.4)',
        }),
        padding: [4, 4, 4, 4],
        textAlign: 'left',
        offsetX: 15
    })
})

const segmentStyle = new Style({
    text: new Text({
        font: '14px Calibri,sans-serif',
        fill: new Fill({
            color: 'rgba(0, 0, 0, 1)' // color texto segmento parcial
        }),
        backgroundFill: new Fill({
            color: 'rgba(245, 215, 0, 1)' // color segmentos parciales
            // color: 'rgba(0, 0, 0, 0.4)',
        }),
        padding: [2, 2, 2, 2],
        textBaseline: 'bottom',
        offsetY: -12
    }),
    image: new RegularShape({
        radius: 6,
        points: 3,
        angle: Math.PI,
        displacement: [0, 8],
        fill: new Fill({
            color: 'rgba(245, 215, 0, 1)' // triangulo inferior color
            // color: 'rgba(0, 0, 0, 0.4)',
        })
    })
})

const segmentStyles = [segmentStyle]

const formatLength = function (line) {
    const length = getLength(line)
    let output
    // output = Math.round(length * 100) / 100 + ' ' + 'm';

    if (length > 100) {
        output = Math.round((length / 1000) * 100) / 100 + ' km'
    } else {
        output = Math.round(length * 100) / 100 + ' m'
    }

    return output
}

const formatArea = function (polygon) {
    const area = getArea(polygon)
    let output
    if (area > 10000) {
        output = Math.round((area / 1000000) * 100) / 100 + ' km\xB2'
    } else {
        output = Math.round(area * 100) / 100 + ' m\xB2'
    }
    return output
}
